<template>
	<div class="col">
		<div class="row">
			<div class="col-md-8">
				<div class="lcpCard">
					<div class="tableWrapper">
						<div class="table">
							<div class="theader">
								<div class="tr">
									<div class="th">Fund</div>
									<div class="th">Category</div>
									<div class="th rating">Stars</div>
									<div class="th">&nbsp;</div>
								</div>
							</div>
							<div class="tbody">
								<div class="tr" v-for="(fund, key) in sortedArray" :key="key" :class="activeClass(fund.ticker)">
									<div class="td name" @click="switchFund(fund.ticker)">{{ fund.name }}</div>
									<div class="td category" :style="{ color: sectorColour(fund) }">{{ getCategory(fund) }}</div>
									<div class="td rating">
										<span>{{ fund.rating }}</span>
									</div>
									<div class="td">
										<div class="btn" @click="toggleFundsToBasket(fund)">{{ actionBtnText(fund.ticker) }}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-4 details-wrapper" v-if="selectedFund !== ''">
				<div class="lcpCard fundDetails">
					<div class="animated" :class="showNewFund">
						<div class="basics">
							<div class="title">Fund Details</div>
							<div class="detail">{{ formattedTests[selectedFund].name }}</div>
							<div class="rating">{{ formattedTests[selectedFund].rating }}</div>
						</div>
						<div class="tests">
							<div class="totalTests">Found in {{ formattedTests[selectedFund].results.length }} tests</div>
							<div class="test" v-for="(test, key) in formattedTests[selectedFund].results" :key="key">
								<div class="test-header" @click="visibleDesc = key">
									{{ test.type }} <span>{{ test.rating }}</span>
								</div>
								<div class="test-body animated" :class="visibleDesc === key ? 'fadeIn' : 'closed'">
									<strong>Date Range:</strong> {{ $moment(new Date(test.dateRange.minDate)).format("Do MMM YYYY") }} -
									{{ $moment(new Date(test.dateRange.maxDate)).format("Do MMM YYYY") }}
									<div v-for="(filters, key) in test.filter.options" class="filters" :key="key">
										<strong>{{ filters.metric }}</strong>
										<span v-for="(values, key) in filters.properties" :key="key">
											{{ filterDisplay(values, filters.metric) }}
											<span v-if="filters.metricSuffix !== null && filters.metric !== 'AUM'">{{ filters.metricSuffix }}</span>
											<span v-if="key < (filters.properties.length - 1 && filters.type === 'Value')"> to </span>
											<span v-if="key < (filters.properties.length - 1 && filters.type === 'Category')">, </span>
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="lcpCard fundDetails" v-if="this.selectedManagers.length > 0">
					<div class="animated" :class="showNewFund">
						<h2>{{ this.selectedManagers.length }} Funds Selected</h2>
						<p>Out of a possible {{ sortedArray.length }} in the list on the left.</p>
						<div class="btn" @click="showManagerCards">View Data Cards</div>
						<img class="selection-img" v-bind:src="selectionImg" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
/* eslint-disable */
import selectionImg from "@/assets/svg/selections.png";
export default {
	data() {
		return {
			addedFunds: [],
			formattedTests: {},
			selectedFund: "",
			sortedArray: [],
			switch: false,
			visibleDesc: 0,
			selectionImg
		};
	},
	created() {
		for (let tests in this.$store.state.testResults) {
			let testName = tests;
			let filters = this.$store.state.testResults[tests].filters;
			for (let filter in filters) {
				let filterSpec = filters[filter].filter;
				let dateRange = filters[filter].dateRange;
				let funds = filters[filter].funds;
				let rating = filters[filter].rating;
				for (let fund in funds) {
					let fundTicker = funds[fund];
					if (this.formattedTests[fundTicker] !== undefined) {
						this.formattedTests[fundTicker].rating = this.formattedTests[fundTicker].rating + rating;
						this.formattedTests[fundTicker].results.push({ type: testName, dateRange: dateRange, filter: filterSpec, rating: rating });
					} else {
						if (this.$store.state.universe.data.keyData.hasOwnProperty(fundTicker)) {
							let name = this.$store.state.universe.data.keyData[fundTicker].name;
							this.formattedTests[fundTicker] = { ticker: fundTicker, rating: rating, name: name, results: [] };
							this.formattedTests[fundTicker].results.push({
								type: testName,
								dateRange: dateRange,
								filter: filterSpec,
								rating: rating
							});
						}
					}
				}
			}
		}
		for (let fund in this.formattedTests) {
			this.sortedArray.push(this.formattedTests[fund]);
		}
		// this.selectedFund =  Object.keys(this.formattedTests)[0];
		this.sortedArray = this.sortedArray.sort(function(a, b) {
			return b.rating - a.rating;
		});

		this.selectedFund = this.sortedArray[0].ticker;
	},
	methods: {
		switchFund(id) {
			this.switch = true;
			this.selectedFund = id;
			setTimeout(() => {
				this.switch = false;
			}, 2000);
		},
		toggleFundsToBasket(fund) {
			if (!this.selectedManagers.find(funds => funds.ticker === fund.ticker)) {
				var selectedArray = {
					comparison: true,
					oIndex: null,
					sortOrder: null,
					ticker: fund.ticker,
					dailyData: [],
					rating: fund.rating
				};
				this.$store.dispatch("addManagerData", selectedArray);
				// this.addedFunds.push(ticker);
			} else {
				this.$store.commit("removeManager", fund.ticker);
				// this.addedFunds.splice(this.addedFunds.indexOf(ticker), 1);
			}
		},
		sectorColour(fund) {
			var fundIndex = this.$store.state.universe.data.allMetaData.findIndex(x => x.Guid === fund.ticker);
			var sectorName = this.$store.state.universe.data.allMetaData[fundIndex].Category;
			var sectorIndex = this.$store.state.universe.data.categoryDimensions[0].order.indexOf(sectorName);
			return this.$store.state.universe.data.categoryDimensions[0].colors[sectorIndex];
		},
		getCategory(fund) {
			var fundIndex = this.$store.state.universe.data.allMetaData.findIndex(x => x.Guid === fund.ticker);
			var sectorName = this.$store.state.universe.data.allMetaData[fundIndex].Category;
			return sectorName;
		},
		filterDisplay(value, metric) {
			if (metric === "Length of track record") {
				return String(value.toFixed(1));
			} else if (metric === "AUM") {
				return `£${value / 1000}bn`;
			} else if (metric === "Standard deviation (% pa)" || metric === "Return (% - pa over 1y)"  || metric === "Max drawdown") {
				return `${Math.round(value * 10) / 10}`;
			} else {
				return value;
			}
		},
		showManagerCards() {
			if (this.selectedManagers.length > 0) {
				this.$store.commit("ui/setNotFullscreen");
				this.$nextTick(i => {
					this.$store.commit("managerView");
				});
			}
		}
	},
	computed: {
		actionBtnText() {
			return ticker => (this.selectedManagers.find(funds => funds.ticker === ticker) !== undefined ? "Remove" : "Add");
		},
		activeClass() {
			return ticker => (this.selectedManagers.find(funds => funds.ticker === ticker) !== undefined ? "active" : "");
		},
		showNewFund() {
			return this.switch ? "fadeIn" : "";
		},
		selectedManagers() {
			return this.$store.state.selectedManagers;
		}
	}
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/all.scss";
.details-wrapper {
	display: flex;
	flex-direction: column;
}
.lcpCard {
	padding: 20px;
}
.tableWrapper {
	height: 85vh;
	overflow: auto;
	.table {
		display: table;
		.tbody {
			display: table-row-group;
		}
		.theader {
			display: table-header-group;
		}
		.tr {
			display: table-row;
			&:nth-of-type(even) {
				background: #fafafa;
			}
			.td,
			.th {
				display: table-cell;
				border-bottom: 1px solid #eee;
				padding: 5px;
				vertical-align: middle;
			}
			.th {
				font-size: 18px;
				font-weight: 800;
				position: sticky;
    			top: 0;
				background: #fff;
			}
			.td {
				&.rating {
					text-align: center;
					font-size: 18px;
					span {
						background: lightgrey;
						padding: 3px;
						border-radius: 6px;
						display: block;
					}
				}
				&.name {
					cursor: pointer;
				}
			}
			&.active {
				background: #ececec;
				.btn {
					background: rgb(223, 63, 111);
				}
			}
			.btn {
				width: 110px;
			}
		}
	}
}
.fundDetails {
	padding: 20px;
	position: relative;
	.basics {
		width: 80%;
		.rating {
			background: lightgrey;
			border-radius: 6px;
			font-size: 48px;
			line-height: 30px;
			padding: 10px;
			position: absolute;
			right: 20px;
			text-align: center;
			top: 65px;
		}
		.title {
			font-size: 18px;
			font-weight: 800;
			margin: 10px 0;
		}
		.detail {
			font-weight: 600;
			margin-bottom: 10px;
		}
	}
	.selection-img {
		width: 200px;
		position: absolute;
		right: 20px;
		top: 25px;
	}
	.tests {
		.totalTests {
			font-size: 18px;
			font-weight: 800;
			margin: 10px 0;
		}
		.test {
			border: 2px solid $LCPWatermelon;
			margin-bottom: 5px;
			position: relative;
			.test-header {
				background: $LCPWatermelon;
				color: white;
				cursor: pointer;
				padding: 10px 5px;
				span {
					background: $LCPMarine;
					border-radius: 6px;
					color: white;
					float: right;
					font-size: 16px;
					font-weight: bold;
					height: 25px;
					margin-top: -2px;
					text-align: center;
					width: 25px;
				}
			}
			.test-body {
				padding: 10px;
				&.closed {
					display: none;
				}
			}
			.rating {
				font-size: 36px;
				position: absolute;
				right: 10px;
				top: 8px;
			}
		}
	}
}
.fundDetails:nth-child(2) {
	margin-top: 30px;
}
@media (max-width: 1536px) {
	.fundDetails {
		.selection-img {
			width: 100px;
		}
	}
	h2 {
		font-size: 20px;
	}
}
</style>
